<p class="graph-title font-primary--b">{{title | translate}}</p>
<div
  class="graph-component type__{{ chartCategory }}"
  [class.unsubscribed]="!subscribed"
  [class.wideMode]="wideMode"
  [class.default]="default"
  *ngIf="!isEmpty"
>
  <!-- <pre>
    {{default}}
    {{chartCategory}}
  </pre> -->
  <div
    class="chart-wrapper"
    [class.chart-wrapper-stats]="stats"
    [style.height]="chartHeight"
  >
    <div
      [class.overlay]="classOverlay"
      [class.overlay-multiple]="classOverlayMultiple"
    ></div>
    <canvas
      #chartCanvas
      #{{chartCategory}}
      id="{{ chartCategory }}"
      [class.canvas-multiple]="classOverlayMultiple"
    ></canvas>
  </div>
  <div class="legend-wrapper" *ngIf="legend">
    <div class="legend" *ngFor="let label of doughnutChartLabels; index as i">
      <div class="color-box" [ngStyle]="{ backgroundColor: colors[i] }"></div>
      <div class="label">
        {{ label }}
      </div>
    </div>
  </div>
  <div class="unsubscribed-card" *ngIf="!subscribed">
    <p class="description">
      {{ description }}
    </p>
    <div class="text-end">
      <a
        class="mt-2 ms-auto d-block text-red"
        routerLink="/dashboard/membership"
      >
        {{ "chartLabels.unlock-statistics-button" | translate }}
      </a>
    </div>
  </div>
</div>
<!-- <pre>
  {{doughnutChartData | json}}
  {{doughnutChartLabels | json}}
  {{colors | json}}
</pre> -->
<div *ngIf="isEmpty">
  <h1 class="graph-title graph-title-no-data"> {{ "chartLabels.no-data" | translate}} </h1>
</div>
